<template>
  <v-app id="inspire">
    <AppBar :drawer.sync="drawer" />
    <AppNavigationDrawer :drawer.sync="drawer" />

    <v-main>
      <v-container fluid grid-list-xl>
        <router-view />
      </v-container>
    </v-main>

    <v-footer padless inset app>
      <div class="flex text-center">
        <div class="ml-1">ASELSAN &copy; {{ new Date().getFullYear() }} {{footer}}</div>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import AppBar from "@/components/layouts/AppBar";
import AppNavigationDrawer from "@/components/layouts/AppNavigationDrawer";
export default {
  name: "home",
  components: { AppBar, AppNavigationDrawer },
  data() {
    return {
      drawer: true,
      footer: process.env.VUE_APP_VERSION +' '+ process.env.VUE_APP_TAG_VERSION,//VUE_APP_BACKEND_ENDPOINT.split('.')[0].substr(21).toUpperCase(),
    };
  },
  beforeCreate() {
    this.$store.dispatch("app/init");
  },
};
</script>